/**
 * @file src/_modulos/prenota/tabela/layouts/config/content/constants.ts
 * @description Constantes simplificadas para a tabela de pré-notas
 *
 * Princípios aplicados:
 * - KISS: Constantes simples e diretas
 * - YAGNI: Apenas o que é realmente necessário
 */

import {
  IconFileText,
  IconUser,
  IconClock,
  IconAlertTriangle,
} from "@tabler/icons-react";
import { ComboboxItem } from "visuais";

/* -------------------------------------------------------------------------- */
/* OPÇÕES DE FILTRO                                                           */
/* -------------------------------------------------------------------------- */

export const TIPOS_NF_OPTIONS: ComboboxItem[] = [
  { value: "Revenda", label: "Revenda" },
  { value: "Despesa/Imobilizado", label: "Despesa/Imobilizado" },
  { value: "Materia Prima", label: "Materia Prima" },
  { value: "Collection", label: "Collection" },
  { value: "Garantia Concebida", label: "Garantia Concebida" },
];

export const STATUS_NF_OPTIONS: ComboboxItem[] = [
  { value: "Pendente", label: "Pendente" },
  { value: "Classificada", label: "Classificada" },
  { value: "Revisar", label: "Revisar" },
  { value: "Verificada", label: "Verificada" },
];

export const PRIORIDADE_OPTIONS: ComboboxItem[] = [
  { value: "Alta", label: "Alta" },
  { value: "Media", label: "Média" },
  { value: "Baixa", label: "Baixa" },
];

/* -------------------------------------------------------------------------- */
/* CONFIGURAÇÕES DE FILTROS                                                   */
/* -------------------------------------------------------------------------- */

export const FILTER_COLUMNS = [
  { key: "F1_DOC", label: "Número da NF", type: "text" as const },
  { key: "F1_COND", label: "Condição", type: "select" as const },
  { key: "A2_NOME", label: "Fornecedor", type: "text" as const },
  { key: "F1_XPRIOR", label: "Prioridade", type: "select" as const },
  { key: "F1_XUSRRA", label: "Usuário", type: "text" as const },
  { key: "F1_VALBRUT", label: "Valor", type: "number" as const, useRange: true},
  {
    key: "F1_EMISSAO",
    label: "Data de Emissão",
    type: "date" as const,
    useRange: true,
  },
  {
    key: "Z05_DATA",
    label: "Data de Inclusão",
    type: "date" as const,
    useRange: true,
  },
  {
    key: "VENCIMENTO",
    label: "Data de Vencimento",
    type: "date" as const,
    useRange: true,
  },
] as const;

export const SELECT_OPTIONS = {
  F1_XPRIOR: PRIORIDADE_OPTIONS.map((opt) => opt.value),
  F1_XTIPO: TIPOS_NF_OPTIONS.map((opt) => opt.value),
  Status: STATUS_NF_OPTIONS.map((opt) => opt.value),
} as const;

export const QUICK_FILTER_FIELDS = {
  FILIAL: "F1_FILIAL",
  STATUS: "Status",
  TIPO: "F1_XTIPO",
} as const;

export const FILTER_FLAGS = {
  SEM_BOLETO: "__SEM_BOLETO__",
} as const;

export const DEFAULT_OPERATOR = "is";

/* -------------------------------------------------------------------------- */
/* CONFIGURAÇÕES DE TABS                                                      */
/* -------------------------------------------------------------------------- */

export const TAB_CONFIGS = [
  {
    key: "todas",
    label: "Todas",
    icon: IconFileText,
    filter: {},
    showBadge: false,
    maxAgeMinutes: 5,
  },
  {
    key: "minhas",
    label: "Minhas",
    icon: IconUser,
    filter: { F1_XUSRRA: "current" },
    showBadge: false,
    maxAgeMinutes: 2,
  },
  {
    key: "pendentes",
    label: "Pendentes",
    icon: IconClock,
    filter: { Status: ["Pendente"], F1_XUSRRA: "current" },
    showBadge: false,
    maxAgeMinutes: 1,
  },
  {
    key: "revisao",
    label: "Revisão",
    icon: IconAlertTriangle,
    filter: { Status: ["Revisar"], F1_XUSRRA: "current" },
    showBadge: false,
    maxAgeMinutes: 1,
  },
  {
    key: "sem_boleto",
    label: "Sem Boleto",
    icon: IconFileText,
    filter: { F1_XUSRRA: "current", [FILTER_FLAGS.SEM_BOLETO]: "1" },
    showBadge: true,
    maxAgeMinutes: 1,
  }
] as const;
